import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Table } from '@quintoandar-tokko/jopijs';
import Trans from '@/components/shared/Trans';
import translations from '@/components/Dashboard/Dashboard.trans.json';
import parentStyles from '../dashboardTables.module.scss';
import specificStyles from './developmentConsultations.module.scss';
import LoadingMoreSkeleton from '../components/LoadingMoreSkeleton';
// TODO: Uncomment when service is available
// import { getPerformanceDevelopmentConsultationsTable } from '@/store/slices/components/dashboard/service';
import buildQuery from '../../utils/buildQuery';
import useObserver from '@/hooks/useObserver';
import { setPerformanceModals } from '@/store/slices/components/dashboard/DashboardSlice';
import HeaderCell from '../components/HeaderCell';
import buildTableQuery from '../../utils/buildTableQuery';
import { TABLE_SORT_FIELDS } from '../../constants';
import useTrackPerformanceTable from '@/components/Dashboard/customHooks/useTrackDashboard';
import { TRACK_ELEMENT } from '@/components/Dashboard/constants/track';
import DevelopmentConsultationsTableRow from './DevelopmentConsultationsTableRow';
import { getPerformanceDevelopmentConsultationsTable } from '@/store/slices/components/dashboard/service';

export default function DevelopmentConsultationsTable() {
  const dispatch = useDispatch();
  const { selectedIds } = useSelector((state) => state.FilterBarSlice.filters);
  const { developmentConsultations } = useSelector(
    (state) => state.DashboardSlice.performanceModals
  );
  const { ref: loadMoreRef, isInViewport } = useObserver();
  const track = useTrackPerformanceTable();

  const headers = [
    {
      id: 1,
      title: Trans(translations, 'Development'),
      subtitle: Trans(translations, 'Location'),
      field: TABLE_SORT_FIELDS.DEVELOPMENT_NAME,
    },
    {
      id: 2,
      title: Trans(translations, 'DevelopmentType'),
      field: TABLE_SORT_FIELDS.DEVELOPMENT_TYPE,
    },
    {
      id: 3,
      title: Trans(translations, 'ConstructionStatus'),
      field: TABLE_SORT_FIELDS.CONSTRUCTION_STATUS,
    },
    {
      id: 4,
      title: Trans(translations, 'AvailableUnits'),
      field: TABLE_SORT_FIELDS.AVAILABLE_UNITS,
    },
    {
      id: 5,
      title: Trans(translations, 'Agent'),
      field: TABLE_SORT_FIELDS.AGENTS_IN_CHARGE,
    },
    {
      id: 6,
      title: Trans(translations, 'Inquiries'),
      field: TABLE_SORT_FIELDS.INQUIRIES,
    },
  ];

  useEffect(() => {
    if (!developmentConsultations.has_next) return;
    if (!isInViewport || developmentConsultations.loading) return;

    const query = buildQuery(selectedIds);
    const tableQuery = buildTableQuery(developmentConsultations, {
      withNextPage: true,
    });

    dispatch(
      getPerformanceDevelopmentConsultationsTable({ query, tableQuery })
    );
  }, [isInViewport]);

  const handleCellClick = (header) => {
    if (!header.field) return;

    dispatch(
      setPerformanceModals({
        key: 'developmentConsultations',
        subkey: 'sortBy',
        value: header.field,
      })
    );
    track.developmentConsultations(TRACK_ELEMENT.COLUMN_ORDER);
  };

  return (
    <Table
      id="development-consultations-table"
      className={`${parentStyles.table} ${specificStyles.developmentConsultationsTable}`}
    >
      <Table.Header className={parentStyles.tableHeader}>
        {headers.map((header) => (
          <HeaderCell
            key={header.id}
            id={header.id}
            title={header.title}
            subtitle={header.subtitle}
            field={header.field}
            sortBy={developmentConsultations.sortBy}
            sortDirection={developmentConsultations.sortDirection}
            onClick={() => handleCellClick(header)}
          />
        ))}
      </Table.Header>

      <Table.Rows>
        {developmentConsultations.list.map((row) => (
          <DevelopmentConsultationsTableRow key={row.id} row={row} />
        ))}

        <Box as="tr" ref={loadMoreRef} style={{ height: 1, opacity: 0 }} />

        {(developmentConsultations.loading ||
          developmentConsultations.has_next) && (
          <LoadingMoreSkeleton columns={headers.length} />
        )}
      </Table.Rows>
    </Table>
  );
}
